import React, { useEffect, useState, useRef } from 'react';
import Editor from 'react-simple-code-editor';
import prism from 'prismjs';

import Spec from '../../../models/Spec';

interface Props {
  spec: Spec
  onSpecChange?: (spec: Spec) => void
}

const Advanced = (props: Props) => {
  const { spec, onSpecChange = () => {} } = props;
  const [text, setText] = useState<string>('');
  const lastValidValue = useRef<string>('');

  const _setValue = (v: string) => {
    try {
      setText(v);
      const _value = JSON.parse(v);
      lastValidValue.current = JSON.stringify(_value, null, 2);
      if (typeof _value !== 'object') return;
      onSpecChange(new Spec(_value));
    } catch {
      // ignore error
    }
  };

  useEffect(() => {
    const _text = JSON.stringify(spec, null, 4);
    if (_text !== lastValidValue.current) {
      lastValidValue.current = _text;
      setText(_text);
    }
  }, [spec]);

  return (
    <div className="w-100" style={{ maxHeight: '400px', overflow: 'auto' }}>
      <Editor
        value={text}
        onValueChange={_setValue}
        highlight={(code) =>
          prism.highlight(code, prism.languages.javascript, 'json')
        }
        padding={10}
        style={{
          fontFamily: '"Fira code", "Fira Mono", monospace',
          backgroundColor: 'rgba(250,250,250, 1)',
          fontSize: 12,
        }}
        textareaClassName="box-border"
        preClassName="box-border"
        autoFocus
      />
    </div>
  );
};

export default Advanced;